//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get, sync } from 'vuex-pathify';
export default {
  name: 'DefaultSurvey',
  components: {
    FibSelectSurvey: require("./SelectSurvey").default
  },
  props: {
    closeButton: {
      type: Boolean
    },
    value: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      currentDefaultTemplate: null,
      showConfirmSurvey: false,
      valueToUpdate: false
    };
  },
  computed: {
    defaultTemplate: sync('settings/defaultTemplate'),
    name: get('surveys/name')
  },
  watch: {
    valueToUpdate: function valueToUpdate(activated) {
      if (activated) {
        this.currentDefaultTemplate = this.defaultTemplate;
      }
    },
    value: function value(_value) {
      this.valueToUpdate = _value;
    }
  },
  created: function created() {
    // Set the 'valueToUpdate' data value to the prop 'value'
    this.valueToUpdate = this.value;
  },
  methods: {
    done: function done() {
      this.$emit('done', {
        name: 'survey',
        result: true
      });
      this.$emit('input');
      this.showConfirmSurvey = false;
    },
    hide: function hide() {
      Logger.debug("Restore default survey to survey id ".concat(this.currentDefaultTemplate));
      this.defaultTemplate = this.currentDefaultTemplate;
      this.$emit('input');
    }
  }
};